import React, { Suspense } from 'react'
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import { CContainer, CFade } from '@coreui/react' 
import { useSelector } from 'react-redux'
// routes config
import routes from '../routes'
  
const loading = (
  <div className="pt-3 text-center">
 
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheContent = () => {
  const show = useSelector(state => state.vals)
  

  const loader= ()=>{  
return (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80vh',
 backgroundColor:'white' 
  }}> 
  
        </div>

);

  }
  const screen = () =>{
return (
  <CContainer >

  <Suspense fallback={loading}>
 
    <Switch>
      {routes.map((route, idx) => {




       
        return route.component && (
          <Route
            key={idx}
            path={route.path}
            exact={route.exact}
            name={route.name}
            render={props => (
              <CFade>
               <route.component {...props} />
              </CFade>
            )} />
        )
      })}
      <Redirect from="/" to="/Home" />
    </Switch>
  </Suspense>

</CContainer>

);

  }
  //var values = JSON.parse(mapData).map(d => d.ID);
  //console.log(values);
  return (
    <main style={{backgroundColor:'white'}}  className="c-main">
     {screen()}
    </main>
  )
}

export default React.memo(TheContent)
